import React from 'react';
import {hot} from 'react-hot-loader';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';

import PublicApp from './PublicApp';
import KeepAliveApp from './KeepAliveApp';

function App() {
  return (
    <Router>
      <div id="optinContentContainer" className="optinBodyText">
        <div>
          <Switch>
            <Route path="/vce/healthcheck" component={PublicApp} />
            <Route path="/vce/io" component={PublicApp} />
            <Route path="/vce/ci" component={PublicApp} />
            <Route path="/vce/keepalive" component={KeepAliveApp} />
            <Route component={PublicApp} />
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default hot(module)(App);
